export interface PartnerLogo {
  src: string
  alt: string
}

interface PartnerLockupProps {
  partnerLogo: PartnerLogo
  className?: string
}

// The store's image is the whole "nelo × partner" lockup, sized per partner by design; nothing is drawn beside it.
export const PartnerLockup = ({ partnerLogo, className = "" }: PartnerLockupProps) => (
  <div data-testid="partner-banner" className={`flex h-[27px] min-w-0 items-center ${className}`}>
    <img src={partnerLogo.src} alt={partnerLogo.alt} decoding="async" className="h-[27px] w-auto min-w-0" />
  </div>
)
